/* eslint-disable */
export default {
    'pageSize': 20,
    'pageSizes': [10, 20, 30, 50, 100],
    // 表格头部的样式
    'headerRowStyle': {
        color: '#666666',
        fontSize: '14px',
        borderRadius: '4px',
        background: '#F1F1F1',
        
    },
    // 头部单元格提示
    'headerCellStyle': {
        background: 'transparent',
        fontWeight: 'normal',
        height: '36px',
        padding: '0 12px',
        color: '#666666',
        borderBottom: 0,
        fontSize: '14px',
        
    },
    'selectionHeaderCellStyle': {
        background: '#F1F1F1',
        fontWeight: 'normal',
        height: '40px',
        padding: '0 0 0 12px',
        borderBottom: 0,
        borderRight: 'none'
        // borderRight: '1px solid #FFFFFF'
    },
    // 所有单元格的样式
    'cellStyle': {
        border: 'none',
        color: '##000000',
        fontSize: '14px',
        height: '44px',
        padding: '0 12px',
    },
    'selectioncellStyle': {
        border: 'none',
        // borderColor: 'rgba(13, 13, 13, 0.06)',
        borderRight: 'none',
        color: '##000000',
        fontSize: '14px',
        height: '44px',
        padding: '0 0 0 12px',
    },
    changeColWidth: function (newWidth, oldWidth, column, event) {
        return new Promise((resolve) => {
            if (column.width < column.minWidth) {
                column.width = column.minWidth
            }
            resolve()
        })
    }
}